'use client';
import { AvatarStyled } from './avatar.styles';

export default AvatarStyled;
